import { Dispatch, SetStateAction, useEffect } from 'react';
import { LocationState } from 'contexts/LocationContext';
import { SolarPanel } from 'svg';
import { HEATMAP_FILTER_VALUE } from 'utils/map';
import { formatNumber } from 'utils/number';
import { FunFacts } from '..';

const HEATMAP_OPTIONS = [
  {
    display: 'Average solar capacity',
    value: HEATMAP_FILTER_VALUE.averageSolarCapacity
  },
  {
    display: 'Number of solar installs',
    value: HEATMAP_FILTER_VALUE.solarInstalls
  }
];

type SolarInfoPanelProps = {
  funFacts: FunFacts;
  setHeatMapFilter: (filter: string) => void;
  setLocation: Dispatch<SetStateAction<LocationState>>;
  onClose: () => void;
};

export default function SolarInfoPanel({
  funFacts,
  setHeatMapFilter,
  setLocation,
  onClose
}: SolarInfoPanelProps) {
  // set default option
  useEffect(() => {
    setHeatMapFilter(HEATMAP_OPTIONS[0].value);
  }, [setHeatMapFilter]);

  return (
    <div
      id="map-info-panel-solar-info-panel"
      className="map-info-panel"
      aria-labelledby="map-info-panel-solar-heading"
      role="dialog"
    >
      <div className="bg-tertiary p-4 text-black">
        <a
          href="javascript:void(0);"
          className="text-xs font-bold text-end underline underline-offset-2"
          onClick={onClose}
        >
          Close
        </a>
        <h4 id="map-info-panel-solar-heading" className="mt-4 text-black h5">
          Solar
        </h4>
      </div>
      <div className="map-info-panel-scroll">
        <div className="info-panel-child-sub-container">
          <p className="text-sm font-bold">Show heatmap for</p>
          <select
            name="solar-info-input-selector"
            id="solar-info-input-selector"
            className="info-panel-child-input-selector"
            onChange={(e) => setHeatMapFilter(e.target.value)}
            autoFocus
          >
            {HEATMAP_OPTIONS.map((option) => (
              <option key={option.display} value={option.value}>
                {option.display}
              </option>
            ))}
          </select>
          <div className="info-panel-child-gradient-progress-bar" />
          <div className="flexrow justify-between">
            <p className="text-xs uppercase">lowest</p>
            <p className="text-xs uppercase">highest</p>
          </div>
        </div>
        <div className="info-panel-child-fun-facts-container">
          <div className="text-sm font-bold">Fun facts</div>

          {funFacts.highestAverageSolarCapacityLocation && (
            <div className="iconned-row flexrow">
              <SolarPanel />
              <div>
                <a
                  href="javascript:void(0);"
                  className="text-sm link-text-redirect"
                  onClick={() =>
                    setLocation(funFacts.highestAverageSolarCapacityLocation)
                  }
                >
                  {funFacts.highestAverageSolarCapacityLocation.location}
                </a>
                <span className="text-sm">
                  &nbsp;has the highest average solar capacity (
                  {formatNumber(funFacts.highestAverageSolarCapacityValue)} kW).
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
